
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';

//
export function CountDown(props: any) {
    function addZero(n: number) {
        if (n < 10)
            return "0" + n;
        return n;
    }

    return (
        <div className={props.className}>
            <span className="count-down-show-digits-cont">
                <div>
                    {addZero(props.days)}
                    <span className="count-down-show-type" >d</span>
                </div>
            </span>

            <span className="count-down-show-digits-cont">
                <div>
                    {addZero(props.hours)}
                    <span className="count-down-show-type">h</span>
                </div>
            </span>

            <span className="count-down-show-digits-cont">
                <div>
                    {addZero(props.minutes)}
                    <span className="count-down-show-type" >m</span>
                </div>
            </span>

            <span className="count-down-show-digits-cont">
                <div>
                    {addZero(props.seconds)}
                    <span className="count-down-show-type">s</span>
                </div>
            </span>

        </div>
    )
}

// Default style!
const CountDownStyled = styled(CountDown)({
    display: "flex",
    borderRadius: "12px",
    background: "#9a793c77",
    justifyContent: "center",
    width: "200px",
    ".count-down-show-digits-cont": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        //border: "1px solid #f1cfae",
        //background: '#ffeede',
        padding: "7px",
        borderRadius: "9px",
        color: "white",
        margin: "3px",
        fontSize: "19px",
        width: "40px",
        height: "30px",
        fontWeight: 700
    },
    ".count-down-show-type": {
        fontSize: "16px",
        color: "white",
        fontWeight: 500
    }
});

// Export
export default CountDownStyled;